
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Layer 2"}},[_c('path',{attrs:{"d":"M18.77 13.36a1 1 0 00-1.41-.13L13 16.86V5a1 1 0 00-2 0v11.86l-4.36-3.63a1 1 0 10-1.28 1.54l6 5 .15.09.13.07a1 1 0 00.72 0l.13-.07.15-.09 6-5a1 1 0 00.13-1.41z","data-name":"arrow-downward"}})])])
          )
        }
      }
    